import { render, staticRenderFns } from "./DialogContractInfo.vue?vue&type=template&id=2c3b4e6b&scoped=true&"
import script from "./DialogContractInfo.vue?vue&type=script&lang=js&"
export * from "./DialogContractInfo.vue?vue&type=script&lang=js&"
import style0 from "./DialogContractInfo.vue?vue&type=style&index=0&id=2c3b4e6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b4e6b",
  null
  
)

export default component.exports